import MainService from "@/services/MainService.js";
import dataTable from "@/components/Datatable";
import Loader from "@/components/Loader";
window.$ = window.jQuery = require("jquery");

export default {
    name: "GenerarViaticoPage",
    data() {
        let ss = new MainService();
        return {
            msg: "GenerarViaticoPage",
            ss: ss,
            auth: {},
            personas: [],
            isLoading: false,
            isLoadingFile: false,
            errorBag: {},
            variables:{},
            rangoViatico:{},
            procesandoRangoViatico: false,
            resultadoRangoViatico: "",
            viatico: {},
            reparticionorigen: [],
            reparticionnueva: [],
            personasSelect:[],
            placeholderPersona:"",
            selectedPersona: null,
            searchPersona:'',
            hasPerson:false,
            placeholderReparticionOrigen:"",
            selectedReparticionOrigen: null,
            searchReparticionOrigen:'',
            placeholderReparticionNueva:"",
            selectedReparticionNueva: null,
            searchReparticionNueva:'',
        };
    },
    methods: {
        
        newPersona() {
            this.persona = {};
            this.$refs['view-persona'].show();
            // console.log("hhhhola")
        },

        enviar() {
            console.log(this.variables.id)
            this.ss.generarviaticogral(this.variables).then(
                (result) => {
                    console.log(result);
                    let response = result.data;
                    console.log(response);
                })
                .catch((error) => {
                    this.errorBag = error.response.data.errors;
                    console.log(error.response.data);
                    this.$bvToast.toast(
                        'Problema al Guardar el Registro, favor verificar los Datos',
                        {
                            title: 'Error',
                            variant: 'danger',
                            autoHideDelay: 5000
                        }
                    )
                });
        },
        generarRangoViatico() {
            const idDesde = parseInt(this.rangoViatico.idDesde, 10);
            const idHasta = parseInt(this.rangoViatico.idHasta, 10);

            this.errorBag = {};
            this.resultadoRangoViatico = "";

            if (Number.isNaN(idDesde) || Number.isNaN(idHasta)) {
                this.errorBag = {
                    id: "Debe ingresar el codigo desde y el codigo hasta"
                };
                return;
            }

            if (idDesde > idHasta) {
                this.errorBag = {
                    id: "El codigo desde no puede ser mayor al codigo hasta"
                };
                return;
            }

            this.procesandoRangoViatico = true;

            this.ss.generarviaticogralrango({
                idDesde: idDesde,
                idHasta: idHasta
            }).then((result) => {
                let response = result.data;
                this.resultadoRangoViatico = "Rango finalizado. Generados: " + response.generados + ". Errores: " + response.errores + ".";

                this.$bvToast.toast(this.resultadoRangoViatico, {
                    title: 'Generar viaticos',
                    variant: response.errores ? 'warning' : 'success',
                    autoHideDelay: 7000
                });
            }).catch((error) => {
                console.log(error.response ? error.response.data : error);
                this.$bvToast.toast(
                    'Problema al generar el rango, favor verificar los datos',
                    {
                        title: 'Error',
                        variant: 'danger',
                        autoHideDelay: 5000
                    }
                )
            }).finally(() => {
                this.procesandoRangoViatico = false;
            });
        },
        imprimirviaticodetallado() {
            this.ss.imprimirviaticodetallado().then(
                (result) => {
                    console.log(result);
                    let response = result.data;
                    console.log(response);
                })
                .catch((error) => {
                    this.errorBag = error.response.data.errors;
                    console.log(error.response.data);
                    this.$bvToast.toast(
                        'Problema al Guardar el Registro, favor verificar los Datos',
                        {
                            title: 'Error',
                            variant: 'danger',
                            autoHideDelay: 5000
                        }
                    )
                });
        },
      
    },
    watch: {
        searchPersona(q) {
            this.ss.select22Persona(q).then((res) => {
                if (res.data.success) {
                   
                    this.personas = res.data.items;
                                   
                } else {
                    this.personas = [];
                }
            })
        },
        selectedPersona(persona){
            this.viatico.Persona = persona.id;
        },
        searchReparticionOrigen(q) {
            this.ss.select2Reparticion(q).then((res) => {
                if (res.data.success) {
                   
                    this.reparticionorigen = res.data.items;
                                   
                } else {
                    this.reparticionorigen = [];
                }
            })
        },
      
        selectedReparticionOrigen(ro){
            this.viatico.ReparticionOrigen = ro.id;
        },
        searchReparticionNueva(q) {
            this.ss.select2Reparticion(q).then((res) => {
                if (res.data.success) {
                   
                    this.reparticionnueva = res.data.items;
                                   
                } else {
                    this.reparticionnueva = [];
                }
            })
        },
        selectedReparticionNueva(rn){
            this.viatico.ReparticionNueva = rn.id;
        },

    },
    components: {
        dataTable,
        Loader
    },
    mounted() {
        var persona = JSON.parse(localStorage.getItem('persona'));
        this.auth = JSON.parse(localStorage.getItem("persona"));
        if (!persona) {
            this.$router.push('/Login');
        } 
    }
};
